module.exports = __webpack_public_path__ + "static/media/access-brikk-preview.96c1c136.png";